import React, { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';
import { Button, ErrorToast } from '../../components';

const UploadContainer = styled.div`
  width: 100%;
  /* max-width: 400px; */
  margin: auto;
  /* padding: 20px; */
  margin-bottom: 20px;
  text-align: center;
`;

const DropBox = styled.div`
  width: 100%;
  height: 150px;
  border: 2px dashed ${({ theme }) => theme.colors.neutral400};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 8px;
  background: #fafafa;

  &:hover {
    background: #f0f0f0;
  }
`;

const HiddenInput = styled.input`
  display: none;
`;

const ImagePreviewContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #ddd;
`;

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255, 0, 0, 0.7);
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FileUpload = ({
  images,
  setImages,
  handleViewImage
}: {
  images: File[];
  setImages: Dispatch<SetStateAction<File[]>>;
  handleViewImage: any;
}) => {
  const handleFiles = (newFiles: FileList | null) => {
    if (!newFiles) return;
    const selectedFiles = Array.from(newFiles).filter((file) =>
      file.type.startsWith('image/')
    );

    if (images.length + selectedFiles.length > 3) {
      ErrorToast('You can only upload up to 3 images.');
      return;
    }

    setImages([...images, ...selectedFiles].slice(0, 3)); // Ensure max 3 files
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  const removeImage = (index: number) => {
    setImages(images.filter((_, i) => i !== index));
  };

  return (
    <UploadContainer>
      <DropBox
        onDragOver={(event) => event.preventDefault()}
        onDrop={handleDrop}
        onClick={() => document.getElementById('fileInput')?.click()}>
        <p>Drag & Drop images here or Click to Upload</p>
      </DropBox>

      <HiddenInput
        id='fileInput'
        type='file'
        multiple
        accept='image/*'
        onChange={(event) => handleFiles(event.target.files)}
      />

      <ImagesPreviewComponent
        images={images}
        removeImage={removeImage}
        handleViewImage={handleViewImage}
      />
    </UploadContainer>
  );
};

export const ImagesPreviewComponent = ({
  images,
  removeImage,
  handleViewImage
}: {
  images: File[];
  removeImage?: (index: number) => void;
  handleViewImage: any;
}) => {
  return (
    <ImagePreviewContainer>
      {images.map((image, index) => (
        <ImageWrapper key={index}>
          <PreviewImage
            src={URL.createObjectURL(image)}
            alt={`Preview ${index + 1}`}
            onClick={() => handleViewImage(URL.createObjectURL(image))}
          />
          {removeImage && (
            <RemoveButton onClick={() => removeImage(index)}>✖</RemoveButton>
          )}
        </ImageWrapper>
      ))}
    </ImagePreviewContainer>
  );
};

export const ImagesPreviewComponent2 = ({
  images,
  handleViewImage
}: {
  images: any[];
  handleViewImage: any;
}) => {
  return (
    <ImagePreviewContainer>
      {images.map((image: any, index: number) => {
        // Check if it's a File (binary image) or a URL string
        const isBinary = image instanceof File;
        const imageUrl = isBinary
          ? URL.createObjectURL(image)
          : image.thumbnailUrl || image.url;

        const imageUrlContent = isBinary
          ? URL.createObjectURL(image)
          : image.contentUrl || image.url;

        return (
          <ImageWrapper key={index}>
            <PreviewImage
              src={imageUrl}
              alt={`Preview ${index + 1}`}
              onClick={() => handleViewImage(imageUrlContent)}
            />
          </ImageWrapper>
        );
      })}
    </ImagePreviewContainer>
  );
};
